import { FunctionComponent } from 'react'
import { Box, Grid, Typography, Switch, SwitchProps } from '@mui/material'
import { Translation } from '@dxp-module/common'
import currencySwitchStyles from './currencySwitch.styles'

type CurrencySwitchProps = {
  labelBefore: string
  labelAfter: string
  disableRipple?: boolean
}

const CurrencySwitch: FunctionComponent<SwitchProps & CurrencySwitchProps> = ({
  disableRipple,
  labelBefore,
  labelAfter,
  ...props
}) => {
  const styles = currencySwitchStyles()

  return (
    <Grid
      component="label"
      container={true}
      alignItems="center"
      spacing={1}
      className={styles.switchContainer}
    >
      <Typography component="p" className={styles.selectCurrency}>
        <Translation id="trans__fincalc__breakdown__select_currency_toggle_label" />
      </Typography>
      <Typography
        component="p"
        className={
          props.checked ? styles.unselectedCurrency : styles.selectedCurrency
        }
      >
        {labelBefore}
      </Typography>
      <Box>
        <Switch
          {...props}
          focusVisibleClassName={styles.focusVisible}
          disableRipple={disableRipple}
          classes={{
            root: styles.root,
            switchBase: styles.switchBase,
            thumb: styles.thumb,
            track: styles.track,
            checked: styles.checked,
          }}
        />
      </Box>
      <Typography
        component="p"
        className={
          props.checked ? styles.selectedCurrency : styles.unselectedCurrency
        }
      >
        {labelAfter}
      </Typography>
    </Grid>
  )
}

export default CurrencySwitch
